import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center text-lg font-extrabold uppercase text-white sm:text-3xl" data-id="element-20" data-mp="avcxsm8avm9h">
          5 <span className="text-electric" data-id="element-21" data-mp="fu6bofri1fa6">premium bonuses</span> included
        </h2>
        <p className="mt-1 text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-22" data-mp="frtkrd3rjukz">
          You'll also receive 5 premium bonuses designed to help you recognize,
          compare, differentiate, practice, and review histology and pathology
          more efficiently.
        </p>
        <div className="mt-2 space-y-2" data-id="element-23" data-mp="3o3pso0957wwe">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-2 border-magenta bg-white px-2.5 py-2" data-id="element-24" data-mp="3t182dsuzig5g">
              <p className="font-heading text-xs font-extrabold uppercase tracking-wide text-magenta sm:text-sm" data-id="element-25" data-mp="1r9329u3c0cjn">
                🎁 Bonus {bonus.number}
              </p>
              <h3 className="mt-0.5 text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-26" data-mp="3icbxs5a1idsn">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm leading-snug sm:text-base" data-id="element-27" data-mp="3r5owjnusc9mn">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}